import type { Profile } from '@capture/shared';

export interface ProfileTabsProps {
  profiles: Profile[];
  activeId: string;
  onSelect: (id: string) => void;
  onAdd: () => void;
}

export function ProfileTabs({ profiles, activeId, onSelect, onAdd }: ProfileTabsProps) {
  // Conditional profiles first (numbered priority), fallback pinned at end.
  const conditional = profiles.filter((p) => !p.isFallback);
  const fallback = profiles.find((p) => p.isFallback);
  const ordered = fallback ? [...conditional, fallback] : conditional;

  return (
    <div role="tablist" className="profile-tabs">
      {ordered.map((p, idx) => (
        <button
          key={p.id}
          role="tab"
          aria-selected={p.id === activeId}
          className={`profile-tab ${p.id === activeId ? 'active' : ''} ${p.isFallback ? 'fallback' : ''}`}
          onClick={() => onSelect(p.id)}
        >
          <span className="priority-chip">
            {p.isFallback ? 'Fallback' : idx + 1}
          </span>
          <span className="profile-name">{p.name}</span>
        </button>
      ))}
      <button className="add-profile-tab" onClick={onAdd}>
        + Add conditional profile
      </button>
    </div>
  );
}
